var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"financial-overview-iframe",attrs:{"src":_vm.iframeUrl,"width":"100%","height":"800","frameborder":"0","scrolling":"auto","sandbox":"allow-scripts allow-same-origin allow-forms allow-popups"}},[_c('p',[_vm._v("Your browser does not support iframes. Please visit the financial overview directly.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }